import type { ITextMessageEntity } from "../../shared/entities";
import type { IMessageEntityClass } from "./message";
import { MessageEntityClass } from "./message";

export interface ITextMessageEntityClass extends IMessageEntityClass<ITextMessageEntity> {}

export class TextMessageEntityClass
	extends MessageEntityClass<ITextMessageEntity>
	implements ITextMessageEntityClass
{
	private content_: ITextMessageEntity["content"];

	constructor(
		type: string,
		content: string,
		msgId: string,
		cliMsgId: string,
		fromUid: string,
		toUid: string,
		sendDttm: number,
	) {
		super(type, msgId, cliMsgId, fromUid, toUid, sendDttm);

		this.content_ = content;
	}

	public toPlainObject(): ITextMessageEntity {
		return {
			type: "text",

			msgId: this.msgId_,
			cliMsgId: this.cliMsgId_,
			fromUid: this.fromUid_,
			toUid: this.toUid_,

			ttl: this.ttl_,

			sendDttm: this.sendDttm_,

			localDttm: this.localDttm_,
			serverTime: this.serverTime_,

			content: this.content_,

			urgency: this.urgency_,

			e2eeStatus: this.e2eeStatus_,
		};
	}

	public updateContent(v: string): void {
		//BIZ RULE: We can or cannot modify message content after a specific message created???
		// this.content_ = v;
	}
}
